import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DatasetField } from 'src/app/model/dataset/field/dataset-field';
import { DraftService } from 'src/app/data-access-layer/draft/draft.service';
import { DataPointField } from './field.class';
import { HttpErrorResponse } from '@angular/common/http';
import { NotifService } from 'src/app/core/notification/notif.service';

@Component({
    selector: 'create-drafts',
    templateUrl: './drafts-create.component.html',
    styleUrls: ['./drafts-create.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DraftsCreateComponent implements OnChanges {

    @Input() fields: DatasetField[] = [];
    @Input() dataset: any;
    @Output() draftCreated = new EventEmitter<string>();

    createDraftForm: UntypedFormGroup;
    draft: any;
    loading = true;

    constructor(
        private readonly draftService: DraftService,
        private readonly formBuilder: UntypedFormBuilder,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly notifService: NotifService
    ) {
        this.createDraftForm = this.formBuilder.group({});
    }

    creationComplete(): void {
        this.initForm();
        this.draftCreated.emit('draft created');
    }

    ngOnChanges() {
        this.fields = this.fields.filter(field => !field.isGenerated);
        this.initForm();
    }

    initForm() {
        this.createDraftForm = this.formBuilder.group({});
        this.fields.forEach(element => {

            this.createDraftForm.addControl(element.name, new UntypedFormControl('', Validators.required));
        });
        this.loading = false;
        // this.createDraftForm = this.formBuilder.group(fields);
    }

    createDraft(value) {
        this.loading = true;
        this.draftService.createDraft(this.dataset.id, this.constructCreateDraftRequest(value)).subscribe((draft) => {
            this.creationComplete();
            this.loading = false;
        }, (error: HttpErrorResponse) => {
            this.loading = false;
            this.handleValidationError(error);
            this.changeDetector.detectChanges();
        });
    }

    handleValidationError(error: HttpErrorResponse): void {
        if (error.status === 400 && error.error?.fieldErrors) {
            const errorFieldNames: string[] = [];
            error.error.fieldErrors.forEach((fieldError: { field: string; code: string }) => {
                const fieldId = fieldError.field.split('.')[0];
                const field = this.fields.find(f => f.id === fieldId);
                if (field) {
                    errorFieldNames.push(field.name);
                }
            });
            if (errorFieldNames.length > 0) {
                const fieldList = errorFieldNames.join(', ');
                this.notifService.error(`Invalid characters in field(s): ${fieldList}. Please correct and try again.`);
            } else {
                this.notifService.error(error.error?.message || 'Validation error. Please check your input.');
            }
        } else {
            const errorMessage = error.error?.message || 'An error occurred. Please try again.';
            this.notifService.error(errorMessage);
        }
    }

    constructCreateDraftRequest(value) {
        let fields = this.objectToArray(value);

        let createDraftRequest = {
            fields: fields
        };
        return createDraftRequest;
    }

    objectToArray(value) {
        let arrayOfValues = [];
        let map = {};
        this.fields.forEach((field) => {
            map[field.name] = field;
        });
        for (let prop in value) {
            if (Object.prototype.hasOwnProperty.call(value, prop)) {
                let field = map[prop];
                field.value = value[prop];
                let datapointField = new DataPointField(field);
                // arrayOfValues.push({ name: prop, value: value[prop], id: map[prop].id })
                arrayOfValues.push(datapointField.fieldValue);
            }
        }
        return arrayOfValues;
    }
}

